/**
 * Class that represents a main title
 */
export class MainTitle {
  /**
   * Title content
   */
  val: string;

  /**
   * Whether the main title is editable
   */
  editable: boolean;

  /**
   *
   * @param value Value for the title
   * @param editable Whether the title is editable
   */
  constructor(value = '', editable = false) {
    this.val = value;
    this.editable = editable;
  }
}
